import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';

export const trackCountryListLinkClick = (
  iso2: string,
  placement: 'top' | 'bottom',
) =>
  pushExploreLinkClicked({
    custom_params: {
      type: 'country_list' as const,
      country_iso2: iso2,
      country_list_placement: placement,
      _clear: true,
    },
  });

export const trackCountryListExpand = (placement: 'top' | 'bottom') => {
  pushExploreLinkClicked({
    custom_params: {
      type: 'country_list_expand' as const,
      country_list_placement: placement,
      _clear: true,
    },
  });
};
